<mat-card appearance="outlined" class="py-1 mt-2 d-flex flex-row align-items-center position-relative gap-3">
	<mat-card-title class="mb-0">Faktura</mat-card-title>
	<span class="fs-7">NIP: {{ ownerNip }}</span>
	<span *ngIf="reservation?.invoice" class="fs-7">Zgłaszący chce fakturę</span>
	<ng-container *ngIf="!reservation?.invoice">
		<span class="fs-7"> Zgłaszający nie chce faktury </span>
	</ng-container>
	<button mat-icon-button [matMenuTriggerFor]="menu" class="position-absolute end-0 fs-5">
		<i class="fa fa-ellipsis-vertical cursor-pointer"></i>
	</button>

	<mat-menu #menu="matMenu">
		<button mat-menu-item *ngIf="!reservation?.invoice" (click)="enableInvoice()">Zgłaszający chce fakturę</button>
		<button mat-menu-item *ngIf="reservation?.invoice" (click)="disableInvoice()">
			Zgłaszający nie chce faktury
		</button>
		<button mat-menu-item (click)="openInvoiceDialog()">Zmień dane fakturowe</button>
	</mat-menu>
</mat-card>
